import React from "react";
import ReactDOM from "react-dom";
// import './index.css';
import "./styles/tailwind.css";
import * as Sentry from "@sentry/browser";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { makeServer } from "./test-server/server";

Sentry.init({
  dsn: "https://5bf4afbf6aae42a69cd63dcf8dfb50aa@sentry.io/5188042",
  environment: process.env.REACT_APP_ENV_OVERRIDE || process.env.NODE_ENV,
});

if (process.env.NODE_ENV === "development") {
  makeServer({ environment: "development" });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
